<template>
    <div>
        <b-card no-body>
            <b-card-body class="px-1 pt-1 pb-0">
                <b-row>
                    <b-col sm="6" lg="3">
                        <label for="idcliente">Cliente</label>
                        <v-select id="idcliente" v-model="clienteSelected" :options="clienteOpt" @input="filtrar()"
                            :reduce="clienteOpt => clienteOpt.value" label="text" key="value" placeholder="Seleccionar..." class="select-size-sm mt-0">
                            <span slot="no-options"> Sin datos</span>
                        </v-select>
                    </b-col>
                    <b-col sm="6" lg="3">
                        <label>Rango de Fechas</label>

                        <flat-pickr v-model="dateRange" class="form-control" placeholder="Select date" :config="{
                            mode: 'range',
                            dateFormat: 'd-m-Y',
                            // locale: 'es'
                        }" @input="filtrar()">
                        </flat-pickr>
                    </b-col>

                </b-row>

            </b-card-body>

            <hr class="invoice-spacing pt-0 pb-0">
            <b-card-body class="px-1 pt-0 pb-0">
                <b-row>
                    <b-col xl="8" lg="8" md="6" sm="6" class="text-left mb-1">
                        <b-button-group v-if="filtrando">
                            <span> Espere, Cargando Data...
                                <b-spinner style="width: 16px; height: 16px;" />
                            </span>
                        </b-button-group>
                    </b-col>
                    <b-col xl="4" lg="4" md="6" sm="6" class="text-right mb-1">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-input-group>

                                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar"
                                    size="sm" />
                                <b-input-group-append>
                                    <b-button :disabled="!filter" @click="filter = ''" size="sm">
                                        Borrar
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                    </b-col>
                </b-row>
            </b-card-body>

            <b-table v-if="$can('read', 'Shipping Advice')" ref="tablesa" responsive hover sticky-header="58vh"
                class="position-relative" :items="items" :fields="fields" :filter="filter"
                :filter-included-fields="filterOn" :busy="loading" show-empty
                empty-text="No se encontraron datos en esta tabla."
                emptyFilteredText="No se encontraron datos del Cliente Seleccionado.">
                <template #table-busy>
                    <div class="text-center text-dark my-1">
                        <b-spinner class="align-middle"></b-spinner> &emsp;
                        <strong>Obteniendo datos...</strong>
                    </div>
                </template>
                <template #cell(estado)="data">
                    <b-badge :variant="status[1][parseInt(data.value)]">
                        {{ status[0][parseInt(data.value)] }}
                    </b-badge>
                </template>
            </b-table>
            <div style="display: none" v-html="miHtml">

            </div>
        </b-card>
    </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'


import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { required, integer, length, max } from '@validations'
import VueContext from 'vue-context'
import {
    BCard, BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BTooltip,
    BModal, VBModal, BListGroup, BListGroupItem, BRow, BCol, BFormFile, BFormTextarea, BSpinner, BButtonGroup, BSidebar, VBToggle,
    BCardText, BForm, BFormDatepicker, BLink, BInputGroupPrepend, BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader, BDropdownDivider,
    BFormCheckbox, VBTooltip
} from 'bootstrap-vue'
import { heightFade } from '@core/directives/animations'
// import flatPickr from 'vue-flatpickr-component'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import { Modal, Button } from 'bootstrap'
import moment from 'moment'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';


export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        VueContext,
        BCard,
        BTable, BFormCheckbox,
        BLink,
        BAvatar,
        BBadge,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BButton,
        BCardBody,
        BTooltip,
        BModal,
        VBModal,
        BListGroup,
        BListGroupItem,
        BRow,
        BCol,
        vSelect,
        VuePerfectScrollbar,
        ToastificationContent,
        BFormFile,
        BFormTextarea, BSpinner, BButtonGroup,
        BSidebar,
        BFormDatepicker, BInputGroupPrepend, BForm,
        BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader, BDropdownDivider,
        flatPickr,
    },
    directives: {
        'b-modal': VBModal,
        'modal': Modal,
        'height-fade': heightFade,
        'b-tooltip': VBTooltip,
        Ripple,
    },

    data() {
        const now = new Date()
        const b_now = new Date()
        b_now.setMonth(b_now.getMonth() - 1)
        return {
            labels: {
                labelPrevDecade: 'Década anterior',
                labelPrevYear: 'Año anterior',
                labelPrevMonth: 'Mes anterior',
                labelCurrentMonth: 'Mes actual',
                labelNextMonth: 'Mes siguiente',
                labelNextYear: 'Año siguiente',
                labelNextDecade: 'Década siguiente',
                labelToday: 'Hoy',
                labelSelected: 'Fecha seleccionada',
                labelNoDateSelected: 'Seleccione fecha de nacimiento',
                labelCalendar: 'Calendario',
                labelNav: 'Navegación por calendario',
                labelHelp: 'Use las teclas de flecha para navegar por el calendario',
                labelTodayButton: 'Hoy',
                labelResetButton: 'Borrar',
                labelClosetButton: 'Cerrar',
            },
            f_ini: b_now.toISOString().split("T")[0],
            f_fin: now.toISOString().split("T")[0],

            opens: "right",//right  center   left
            dateRange: `${b_now.getDate()}-${b_now.getMonth() + 1}-${b_now.getFullYear()} to ${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}`,
            singleDatePicker: "range",
            autoApply: true,
            ranges: false,
            showWeekNumbers: true,

            checkbox: false,
            loading: false,
            loadingCorreo: false,
            filtrando: false,
            items: [],
            filter: null,
            filterOn: [],
            estadoModal: false,

            infoModal: {
                title: '',
                boton: '',
            },
            fields: [
                {
                    key: 'cliente',
                    label: 'cliente',
                    tdClass: 'alinear-una-sola-linea'
                },
                {
                    key: 'cultivo',
                    label: 'cultivo',
                    tdClass: 'alinear-una-sola-linea'
                },
                {
                    key: 'semana',
                    label: 'semana',
                    tdClass: 'alinear-una-sola-linea'
                },
                {
                    key: 'zona',
                    label: 'zona',
                    tdClass: 'alinear-una-sola-linea'
                },
                {
                    key: 'fecha_envio',
                    label: 'fecha envio',
                    tdClass: 'alinear-una-sola-linea'
                },
                // {
                //     key: 'asunto',
                //     label: 'asunto',
                //     tdClass: 'alinear-una-sola-linea'
                // },
                {
                    key: 'estado',
                    label: 'estado',
                    tdClass: 'alinear-una-sola-linea'
                }

            ],
            status: [
                {
                    0: 'Enviado',
                    1: 'No Enviado',
                },
                {
                    0: 'light-success',
                    1: 'light-danger',
                }
            ],

            clienteOpt: [],
            clienteSelected: '',
            emailOpt: [],
            correoSelected: '',

            validacion: null,
            destinosSelected: null,
            destinosOpt: [],
            correo: '',
            contenido: "",
            asunto: '',

            miHtml: '',



        }
    },
    computed: {},
    mounted() {
        this.filtrar();
        this.traerShippingAdvice('INI');

    },
    methods: {
        dateFormat(classes, date) {
            if (!classes.disabled) {
                classes.disabled = date.getTime() < new Date()
            }
            return classes
        },
        date(val) {
            return val ? val.toLocaleString() : ''
        },

        onContext(ctx) {
            // The date formatted in the locale, or the `label-no - date - selected` string
            this.formatted = ctx.selectedFormatted
            // The following will be an empty string until a valid date is entered
            this.selected = ctx.selectedYMD
        },
        filtrar() {
            // console.log(this.dateRange)
            let fecha_array = this.dateRange.split(' to ')
            if (fecha_array.length == 2) {

                let sep_feha_in = fecha_array[0].split('-')
                let sep_feha_fin = fecha_array[1].split('-')
                this.f_ini = sep_feha_in[2] + '-' + sep_feha_in[1] + '-' + sep_feha_in[0]
                this.f_fin = sep_feha_fin[2] + '-' + sep_feha_fin[1] + '-' + sep_feha_fin[0]
                this.traerShippingAdvice('Filtro')
            }
        },
        traerShippingAdvice(type) {
            const yo = this
            yo.loading = true
            yo.filtrando = true
            var cliente = yo.clienteSelected;
            if (cliente == '') cliente = 'T';

            var getFiltro = '' +
                'cliente=' + cliente +
                '&f_ini=' + yo.f_ini +
                '&f_fin=' + yo.f_fin

            const config = {
                method: 'post',
                url: '/comex/emails_enviados/?' + getFiltro
            }

            axiosIns(config)
                .then(function (response) {
                    if (response.status === 200) {
                        yo.items = response.data
                        if (type == 'INI') {
                            yo.llenarSelectores();
                        }
                        yo.CambioFormatoFecha();

                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(function () {
                    yo.loading = false
                    yo.filtrando = false
                    if (type != 'INI') {

                        yo.mostrarNotificacion('Correcto', 'CheckIcon', 'Los Datos se Cargaron Correctamente', 'success')
                    }
                })
        },
        llenarSelectores() {
            let yo = this;
            yo.clienteOpt = [];
            for (let value of yo.items) {
                if (value.cliente != null && value.cliente !== '' && value.cliente !== ' ' && value.cliente !== '  ') {
                    yo.clienteOpt.push({ value: value.cliente, text: value.cliente })
                }
            }
            yo.clienteOpt.sort((a, b) => a.value.localeCompare(b.value));
            yo.clienteOpt.unshift({ value: 'T', text: "TODOS" });
            let setCliente = new Set(yo.clienteOpt.map(JSON.stringify));
            yo.clienteOpt = Array.from(setCliente).map(JSON.parse);
            yo.clienteSelected = "T";
        },
        CambioFormatoFecha() {
            let yo = this;
            for (let value of yo.items) {
                if (value.fecha_envio != null && value.fecha_envio !== '' && value.fecha_envio !== ' ' && value.fecha_envio !== '  ') {
                    value.fecha_envio = moment(String(value.fecha_envio)).add(5, 'h').format('HH:mm:ss DD/MM/YYYY')
                }
            }

        },
        mostrarModal() {
            this.checkbox = false;
            if (this.clienteSelected == "" || this.clienteSelected == "T" ||
                this.cultivoSelected == "" || this.cultivoSelected == "T" ||
                this.semanaSelected == "" || this.semanaSelected == "T" ||
                this.zonaSelected == "" || this.zonaSelected == "T"
            ) {
                yo.mostrarNotificacion('Error', 'CheckIcon', 'Debe Seleccionar Correctamente los Datos a Filtrar', 'warning')
            } else if (this.items.length == 0) {
                yo.mostrarNotificacion('Error', 'CheckIcon', 'No Existen Datos para enviar', 'warning')
            } else {
                this.cargarClientes()
                this.cargarDatosFiltrados()
                this.estadoModal = true
                this.infoModal.title = 'Enviar Correo'
                this.infoModal.boton = 'Enviar'
            }

        },
        cargarDatosFiltrados() {
            var cult_eng = ""
            if (this.cultivoSelected == "ARANDANO CONV.") {
                cult_eng = "CONVENTIONAL BLUEBERRY"
            } else if (this.cultivoSelected == "ARANDANO ORGANICO") {
                cult_eng = "ORGANIC BLUEBERRY"
            } else if (this.cultivoSelected == "ESPARRAGO") {
                cult_eng = "ASPEARAGUS"
            } else if (this.cultivoSelected == "UVA") {
                cult_eng = "GRAPE"
            } else {
                cult_eng = this.cultivoSelected
            }


            this.asunto = 'AGROVISION SHIPMENT REPORT WK ' + this.semanaSelected.substring(4, 6) + ' / ' + this.clienteSelected;
            this.contenido = "Dear Sirs,\nWe are pleased to inform you the details of merchandising dispatched as attached:\n\nSHIPPER:  AGROVISION PERU S.A.C.\nCUSTOMER: " + this.clienteSelected + "\nCROP: " + cult_eng + "\nWK: " + this.semanaSelected.substring(4, 6) + "\n\nNote:\nWhen sending final sales reports or liquidations please add sales@agrovisioncorp.com to the list of recipients.\n\nGracias & Saludos / Thanks & Rgds.";

        },
        cargarClientes() {
            this.emailOpt = [];
            this.correoSelected = "";
            let cliente = "";
            cliente = this.clienteSelected
            if (cliente == "") {
                cliente = "T"
            }
            for (let value of this.correosAll) {
                if (value.name1 == this.clienteSelected) {
                    this.emailOpt.push({ value: value.correo_oficial, text: value.correo_oficial })
                }
            }
            for (let index = 0; index < this.emailOpt; index++) {
                const element = array[index];
            }
        },

        enviarFormulario() {

            if (this.destinosOpt.length <= 0) {
                this.$swal.fire('Mensaje', 'Ingrese un correo válido!', 'warning').then((result) => { });
                return;
            }
            this.$nextTick(() => {
                var yo = this

                var contenido = this.contenidoHtml();
                var correos = "";
                // this.destinosOpt.push({ value: "meysi.limo@agrovisioncorp.com", text: "meysi.limo@agrovisioncorp.com" })
                for (var i = 0; i < this.destinosOpt.length; i++) {
                    correos = correos + this.destinosOpt[i].value + "[-@@-]";
                }

                yo.loadingCorreo = true;

                var cliente = yo.clienteSelected;
                var cultivo = yo.cultivoSelected;
                var semana = yo.semanaSelected;
                var zona = yo.zonaSelected;
                if (cliente == '') cliente = 'T';
                if (cultivo == '') cultivo = 'T';
                if (semana == '') semana = 'T';
                if (zona == '') zona = 'T';

                var qs = require('qs');
                var data = qs.stringify({
                    "correo": correos,
                    "asunto": yo.asunto,
                    "text_content": yo.contenido,
                    "html_content": this.miHtml,
                    "cliente": cliente,
                    "cultivo": cultivo,
                    "semana": semana,
                    "zona": zona

                });



                var url = "/comex/shippingadvice/enviarcorreo/"

                var config = {
                    method: 'post',
                    url: url,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    data: data
                };

                axiosIns(config)
                    .then(function (response) {

                        if (response.status === 201 || response.status === 200) {

                            let resul = response.data;

                            if (resul.enviado == 'si') {
                                yo.mostrarNotificacion('Correo enviado con éxito', 'CheckIcon', 'El correo ' + '' + ' ha sido enviado correctamente', 'success')
                            } else {
                                yo.mostrarNotificacion('Error de enviado', 'AlertCircleIcon', 'El correo no se pudo enviar, Revisar Error' + '"' + resul.mensaje + '"', 'warning')
                            }

                        } else {
                            yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                        yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
                    }).finally(function () {
                        yo.loadingCorreo = false;


                    });

                this.estadoModal = false
            })


            // Hide the modal manually
        },

        agregarCorreo() {
            var yo = this;
            if (this.correoSelected == '', this.correoSelected.indexOf("@") <= 0) {
                yo.$swal.fire('Mensaje', 'Ingrese un correo válido!', 'warning').then((result) => { })
                return;
            }
            yo.destinosOpt.push({ value: this.correoSelected, text: this.correoSelected })
            yo.destinosSelected = this.correoSelected;
            this.correoSelected = '';

        },
        eliminarCorreo() {
            var yo = this;
            if (yo.destinosSelected != null) {
                var index = yo.destinosOpt.indexOf(yo.destinosSelected)
                yo.destinosOpt.splice(index, 1)
                yo.destinosSelected = "";
            }
        },

        resetModal() {
            this.correo = ''
            this.destinosSelected = ''
            this.destinosOpt = []
            // this.asunto = ''
            // this.contenido = ''
            // this.nomnbres_remitente = ''
            // this.apellidos_remitente = ''
            // this.telefono = ''
            // this.correo_remitente = ''

            this.validacion = null
            this.resetInfoModal()
        },

        okModal(bvModalEvt) {

            bvModalEvt.preventDefault()

            this.enviarFormulario()
        },
        resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.boton = ''
            this.estadoModal = false
        },
        mostrarNotificacion(titulo, icono, texto, variante) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: titulo,
                    icon: icono,
                    text: texto,
                    variant: variante
                }
            },
                {
                    timeout: 5000
                })
        },

        contenidoHtml() {
            let result = this.contenido.replaceAll("\n", "<br>");
            result = result.replace("SHIPPER:", "<b>SHIPPER:</b>");
            result = result.replace("CUSTOMER:", "<b>CUSTOMER:</b>");
            result = result.replace("CROP:", "<b>CROP:</b>");
            result = result.replace("WK:", "<b>WK:</b>");
            result = result.replace("Note:", "<b>Note:</b>");

            this.miHtml = "<div>\n" +
                "           <div>\n" +
                "             <p>" + result + "</p>\n" +
                "           </div>\n" +
                "         </div>";


        }

    },
}
</script>

<style lang="scss">
.alinear-una-sola-linea {
    white-space: nowrap !important;
}

// @import "https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
</style>
